<template>
    <div class="personZuzhi">
        <el-card class="box-card fl">
            <div slot="header" class="clearfix header">
                <span class="card-header">组织机构</span>
            </div>
            <el-aside width="300px" style="padding: 15px;"> 
                <el-tree
                    ref="eventCategoryTree"
                    :data="theData"
                    :props="defaultProps"
                    node-key="id"
                    highlight-current
                    default-expand-all
                    :render-content="renderContent"
                    :expand-on-click-node="false"> 
                </el-tree> 
            </el-aside>
            <el-dialog :title="textMenu[dialogMenuStatus]" class="add-event-dialog" :visible.sync="addEventdialogVisible" @close='emptyDialog'> 
                <el-form ref="editStatus" :model="editStatus" :label-position="labelPosition" label-width="120px" :rules="editEventNodeRules"> 
                    <el-form-item label="上级组织名称" prop="deptName" style="width: 48%" class="fl"> 
                        <el-input clearable v-model.trim="editStatus.deptName" :disabled="true"></el-input> 
                    </el-form-item> 
                </el-form>
                <el-form class="clearfix" ref="addEventForm" label-width="80px" :model="addEventForm" :label-position="labelPosition" :rules="addEventNodeRules"> 
                    <el-form-item label="组织名称" prop="deptName" style="width: 48%" class="fr"> 
                        <el-input clearable type="text" maxlength="100"  v-model.trim="addEventForm.deptName" show-word-limit></el-input> 
                    </el-form-item>
                    <el-form-item label="组织编码" prop="deptCode" style="width: 48%" class="fl"> 
                        <el-input clearable v-model.trim="addEventForm.deptCode" maxlength="50" show-word-limit></el-input> 
                    </el-form-item>
                    <el-form-item label="联系人" prop="deptLinkman" style="width: 48%" class="fr"> 
                        <el-input clearable maxlength="20" v-model.trim="addEventForm.deptLinkman" show-word-limit></el-input> 
                    </el-form-item>
                    <el-form-item label="联系电话" style="width: 48%" class="fl" prop="deptLinkmanPhone"> 
                        <el-input clearable maxlength="30" v-model.trim="addEventForm.deptLinkmanPhone" show-word-limit></el-input> 
                    </el-form-item>
                    <el-form-item label="电子邮件" style="width: 48%" class="fr"> 
                        <el-input clearable maxlength="30" v-model.trim="addEventForm.deptLinkmanEmail" show-word-limit></el-input> 
                    </el-form-item>
                    <el-form-item label="备注" prop="memo" class="fl" style="width:100%"> 
                        <el-input clearable maxlength="1000" type="textarea" v-model.trim="addEventForm.memo" autosize style="height: 50px;" show-word-limit></el-input> 
                    </el-form-item>
                </el-form> 
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('addEventForm')">添加</el-button>
                    <el-button v-else type="success" @click="saveEventFormSubmitBtn('addEventForm')">保存</el-button> 
                    <el-button @click="addEventFormCancleBtn()">取 消</el-button> 
                </span> 
            </el-dialog>
        </el-card>
        <el-card class="box-card box-card-big fr">
            <div slot="header" class="clearfix header">
                <span class="card-header fl">用户信息</span>
                <el-button class="fr" size="mini" type="success" @click="handleAddForm()" v-if="personAuth.handleAddForm">新增</el-button>
            </div>
            <!-- dialog对话框 -->
            <!-- 新增界面 -->
            <el-dialog title="新增用户信息" :visible.sync="dialogAddFormVisible" :close-on-click-modal="false" width="70%">
                <el-form class="clearfix" :label-position="labelPosition" :model="watchEventForm" :rules="watchEventFormRules"  label-width="100px" ref="watchEventForm">
                    <el-form-item label="部门:" prop="deptName" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable v-model.trim="watchEventForm.deptName" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名:" prop="staffName" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable maxlength="20" v-model.trim="watchEventForm.staffName" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <el-form class="clearfix" :label-position="labelPosition" :model="addUserForm" :rules="addUserFormRules"  label-width="100px" ref="addUserForm">
                    <el-form-item label="登录名:" prop="loginName" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable maxlength="30" v-model.trim="addUserForm.loginName" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="密码:" prop="password" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable type="password" maxlength="30" v-model.trim="addUserForm.password" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" prop="loginPassword2" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable type="password" maxlength="30" v-model.trim="addUserForm.loginPassword2" show-word-limit></el-input>
                    </el-form-item>    
                    <el-form-item label="性别:" prop="staffSex" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-select v-model="addUserForm.staffSex" placeholder="请选择员工性别" style="width: 100%;">
                            <el-option :label="item.product_type" :value="item.categorya_id" v-for="(item,index) in contractLists" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工号:" prop="jobNo" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable type="text" maxlength="30" v-model.trim="addUserForm.jobNo" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="职务:" prop="staffDuty" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable type="text" maxlength="30" v-model.trim="addUserForm.staffDuty" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable type="text" maxlength="20" v-model.trim="addUserForm.staffPhone" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱:" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-input clearable type="text" maxlength="30" v-model.trim="addUserForm.staffEmail" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="区域:" prop="region" style="width: 48%;margin-right: 15px;" class="fl">
                        <el-cascader ref="regionAdd" clearable  style="width:100%"  v-model="addUserForm.region"  :options="regionData" :props="lazyRegin"  filterable></el-cascader>
                    </el-form-item>
                    <el-form-item label="备注:" prop="momo" style="width: 100%;" class="fl">
                        <el-input clearable type="textarea" maxlength="1000" v-model.trim="addUserForm.momo" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="success" @click="createData">添加</el-button>
                    <el-button type="warning" @click.native="dialogAddFormVisible=false">取消</el-button>
                </div>
            </el-dialog>
            <el-row>
                <el-table :data="configureInfo" highlight-current-row border style="width: 100%;" :header-cell-style="{'text-align':'center'}">
                    <el-table-column prop="deptId" label="部门" width="150" align="center" sortable></el-table-column>
                    <el-table-column prop="staffName" label="姓名" width="150" sortable align="center"></el-table-column>
                    <el-table-column prop="loginName" label="账号" width="150" align="center" sortable></el-table-column>
                    <el-table-column label="操作" min-width="150" align="center" v-if="personAuth.handleEditForm ||personAuth.handleDel || personAuth.changePassword || personAuth.numberQuery">
                        <template slot-scope="scope">
                            <el-dropdown  trigger="click">
                                <el-button type="primary" size="mini">
                                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleEditForm(scope.$index, scope.row)" v-if="personAuth.handleEditForm">
                                        修改用户
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDel(scope.$index, scope.row)" v-if="personAuth.handleDel">删除用户</el-dropdown-item>
                                    <el-dropdown-item @click.native="changePassword(scope.$index, scope.row)" v-if="personAuth.changePassword">重置密码</el-dropdown-item>
                                    <el-dropdown-item @click.native="numberQuery(scope.$index, scope.row)" v-if="personAuth.numberQuery">账号授权</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- dialog对话框 -->
                <!--修改界面-->
                <el-dialog title="修改用户信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="70%">
                    <el-form class="clearfix" :label-position="labelPosition" :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                        <el-form-item label="部门:" prop="deptId" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="30" v-model.trim="editForm.deptId" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名:" prop="staffName" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="30" v-model.trim="editForm.staffName" type="text" show-word-limit></el-input>
                        </el-form-item>
                    </el-form>
                    <el-form class="clearfix" :label-position="labelPosition" :model="addUserForm" label-width="100px" ref="addUserForm" :rules="addUserFormRules">
                        <el-form-item label="登录名:" prop="loginName" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="30" v-model.trim="addUserForm.loginName" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="工号:" prop="jobNo" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="30" type="text" v-model.trim="addUserForm.jobNo" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="职务:" prop="staffDuty" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="30" type="text" v-model.trim="addUserForm.staffDuty" show-word-limit></el-input>
                        </el-form-item>
                       <el-form-item label="联系电话:" prop="staffPhone" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="20" type="text" v-model.trim="addUserForm.staffPhone" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱:" prop="staffEmail" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-input clearable maxlength="30" type="text" v-model.trim="addUserForm.staffEmail" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="区域:" prop="region" style="width: 48%;margin-right: 15px;" class="fl">
                            <el-cascader ref="regionUpdate" clearable style="width:100%"  v-model="addUserForm.region"  :options="regionData" :props="lazyRegin"  filterable></el-cascader>
                        </el-form-item>
                        <el-form-item label="备注:" prop="momo" style="width: 100%;" class="fl">
                            <el-input clearable maxlength="1000" type="textarea" v-model.trim="addUserForm.momo" show-word-limit></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="success" @click="updateData()">保存</el-button>
                        <el-button type="warning" @click.native="dialogFormVisible=false">取消</el-button>
                    </div>
                </el-dialog>
                <!-- 账号权限界面 dislogNumberQuery -->
                <el-dialog title="账号权限" :visible.sync="dislogNumberQuery" :close-on-click-modal="false">
                    <el-form :label-position="labelPosition" :model="NumberQueryForm" label-width="100px" :rules="NumberQueryFormRules" ref="NumberQueryForm">
                        <el-row>
                            <el-form-item label="姓名:" prop="staffName" style="width: 48%;" class="fl">
                                <el-input clearable maxlength="30" v-model.trim="NumberQueryForm.staffName" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="登录名:" prop="loginName" style="width: 48%;" class="fr">
                                <el-input clearable maxlength="30" v-model.trim="NumberQueryForm.loginName" :disabled="true"></el-input>
                            </el-form-item>
                        </el-row>
                    </el-form>
                    <el-form :label-position="labelPosition" :model="userRole" ref="userRole" label-width="100px">
                        <el-form-item label="角色名:">
                            <el-radio-group v-model="userRole.checked">
                                <el-radio name="userRole" v-for="(item,index) in roleList" :label="item.roleId" :key="index" :value="item.roleId">{{item.roleName}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="success" @click="numberQueryAgin()">确定</el-button>
                        <el-button @click.native="dislogNumberQuery = false">取消</el-button>
                    </div>
                </el-dialog>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
    import { getDeptlist,getUserListByDept,deptAdd,deptInfo,deptEdit,delDept,getUserInfoById,userAdd,userEdit,userDis,userDel,userResPwd,getAuthInfo,userAuth } from '../../api/api'
    import TreeRender from './components/tree_render_new.vue';
    import {getPermission} from '../../api/authRequest'
    import { getRegionTree } from '../../api/system';

    export default {
        name: 'personZuzhi',
        data () {
            let _self=this;
            const validatePhone = (rule, value, callback) => {
                if (value === ''||value===undefined||value==null) {
                    callback()
                } else {
                    if (!(/^1[345789]\d{9}$/.test(value))) {
                        callback(new Error('请输入正确的11位手机号'))
                    }
                    callback()
                }
            }
            const validateEmail = (rule, value, callback) => {
                if (value === ''||value===undefined||value==null) {
                    callback()
                } else {
                    if (!(/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(value))) {
                        callback(new Error('请输入正确的邮箱地址'))
                    }
                    callback()
                }
            }
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'))
                } else {
                    if (this.addUserForm.loginPassword2 !== '') {
                        this.$refs.addUserForm.validateField('loginPassword2')
                    }
                    if (!(/^(?=.*[a-z])(?=.*\d)[^]{8,30}$/.test(value))) {
                        callback(new Error('最少8个字符，需包含字母及数字'))
                    }
                    callback()
                }
            }
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'))
                } else if (value !== this.addUserForm.password) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            }
            return {
                eventCategoryTree: [],
                //获取上级组织
                editStatus:{
                    DeptId:'',
                    deptName: '极吼吼'
                },
                editEventNodeRules:{
                    deptName: [{ required: true, message: "请输入组织名称", trigger: "blur" }],
                    deptLinkmanPhone: [{ validator: validatePhone, trigger: 'blur',required: false}],
                    deptLinkmanEmail: [{ validator: validateEmail, trigger: 'blur',required: false}],
                },
                defaultProps: { children: 'children', label: 'label' }, 
                /*触发的当前的节点，放到全局，方便调用*/
                triggerCurrenNodeData:{}, /*触发的当前节点*/ 
                triggerCurrenNode:{}, /*新增事件弹窗的输入框数据*/ 
                addEventdialogVisible: false, 
                //填写or修改组织名称
                addEventForm:{ 
                    deptName: '',
                    deptCode: '',
                    deptLinkman: '',
                    deptLinkmanPhone: '',
                    deptLinkmanEmail: '',
                    memo: ''
                },
                addEventNodeRules:{
                    deptName: [{ required: true, message: "请输入组织名称", trigger: "blur" }],
                    deptLinkmanPhone: [
                        { validator: validatePhone, trigger: 'blur',required: false, }
                    ],
                    deptLinkmanEmail: [
                        { validator: validateEmail, trigger: 'blur',required: false, }
                    ]
                },
                menuId:'',
                theData: [],
                childMenuShow:false,
                dialogVisible:false,
                dialogDel:false,
                labelPosition: 'left',
                formLabelAlign: {
                    name: '',
                    number: ''
                },
                orderLists: [],
                subOrderId: '',
                menuLists: [],
                contractLists:[
                    {categorya_id: 1, product_type: "男"},
                    {categorya_id: 2, product_type: "女"},
                ],
                watchEventForm:{ 
                    deptName: '',
                    deptCode: '',
                    deptLinkman: '',
                    deptLinkmanPhone: '',
                    deptLinkmanEmail: '',
                    memo: '',
                    staffName: ''
                },
                watchEventFormRules: {
                    deptName: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
                    staffName: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
                },
                configureInfo: [
                    {
                        deptId: '',//部门名称
                        staffName: "",//姓名
                        loginName: '',//账号
                        userId: '',//员工id
                    }
                ],
                addUserForm: { 
                    loginName: '',//账号
                    password: "",
                    passWordStrong: '弱',
                    loginPassword2: '',
                    staffSex: '',
                    jobNo: '',
                    staffDuty: '',//职位
                    staffEmail: '',
                    staffPhone:"",
                    staffName:'',
                    region:[],
                    momo:'',
                },
                addUserFormRules: {
                    staffName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                    loginName: [{ required: true, message: "请输入登陆名", trigger: "blur" }],
                    password: [{validator: validatePass,required: true, trigger: 'blur'}],
                    loginPassword2: [{validator: validatePass2, required: true,trigger: 'blur'}],
                    staffPhone: [
                        { 
                            validator: validatePhone, trigger: 'blur' 
                        }
                    ],
                    staffEmail: [
                        { 
                            validator: validateEmail, trigger: 'blur' 
                        }
                    ]
                },
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                dialogAddFormVisible:false,
                dialogStatus: "",
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改组织机构",
                    create: "新增组织机构"
                },
                getUserRorm:{
                    userId: '',
                },
                //新增界面数据
                dialogFormVisible:false,
                editForm: {
                    deptId: '',//部门名称
                    staffName: "",//姓名
                    loginName: '',//账号
                    password: "",
                    passWordStrong: '弱',
                    loginPassword2: '',
                    jobNo: '',
                    staffDuty: '',//职位
                    staffEmail: '',
                    staffPhone:"",
                    region:[],
                    momo:'',
                    staffSex: ''
                },
                editFormRules: {
                    deptId: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
                    staffName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                    loginUserName: [{ required: true, message: "请输入登陆名", trigger: "blur" }],
                },
                //修改用户信息
                dialogFormUserVisible:false,
                //禁用账号
                dialogFormDisableVisible:false,
                dislogNumberQuery:false,
                NumberQueryForm: {
                    staffName: "",
                    loginName: '',
                    userRole: ''
                },
                userRole: {
                    checked: '',
                },
                roleList:[],
                NumberQueryFormRules: {
                    staffName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                    loginName: [{ required: true, message: "请输入登陆名", trigger: "blur" }],
                },
                personAuth:{
                    handleAddForm:false,
                    handleEditForm:false, 
                    handleDel:false, 
                    changePassword:false, 
                    numberQuery:false,
                },
                regionData:[],
                lazyRegin:{
                    value:"id",
                    label:'name'
                }
            }
        },
        mounted () {
            this.subOrderId = this.$route.query.subOrderId
            let compParam = {
                subOrderId: this.subOrderId
            }
            this.getDeptLists();
            this.configureInfo = [];
            this.personAuth.handleAddForm= getPermission('/system/dept/userAdd');
            this.personAuth.handleEditForm= getPermission('/system/dept/userEdit');
            this.personAuth.handleDel= getPermission('/system/dept/userDel');
            this.personAuth.changePassword= getPermission('/system/dept/userResPwd');
            this.personAuth.numberQuery= getPermission('/system/dept/userAuth');
            // console.log(this.personAuth)
            this.getRegion({isOpen:1})
        },
        methods: {
            //清空dialog
            emptyDialog:function() {
                this.addEventForm = {}
                this.addEventdialogVisible = false
            },
            //获取组织机构列表
            getDeptLists() {
                getDeptlist().then(res => {
                    if (res.data.status == 100) {
                        this.theData = res.data.results.Deptlist
                        // console.log(this.theData)
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            }, 
            /*渲染函数*/ 
            renderContent(h, { node, data, store }) { 
                let that = this;//指向vue 
                return h(TreeRender,
                    { 
                        props:{ NODE: node, DATA: data, STORE: store, }, 
                        on:{ 
                            //新增节点
                            Append: ((s,d,n) => that.appendEvent(s,d,n)),
                            //修改节点 
                            Edit: ((s,d,n) => that.EditEvent(s,d,n)),
                            //删除节点
                            Delete: ((s,d,n) => that.removeEvent(s,d,n)),
                            //查看节点
                            WatchInfo: ((s,d,n)=> that.WatchEvent(s,d,n))
                        }
                    }
                );
            },
            /*树形控件添加节点，添加弹窗出现*/
            appendEvent(s,d,n) {
                this.addEventdialogVisible = true;
                this.dialogMenuStatus = "create";
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.editStatus = Object.assign({}, d);
                console.log(this.editStatus.deptName)
            },
            /*树形控件修改节点，修改弹窗出现*/
            EditEvent(s,d,n) {
                this.addEventdialogVisible = true;
                this.dialogMenuStatus = "update";
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.editStatus = Object.assign({}, d);
                // console.log(this.editStatus.deptId)
                let para = { 
                    deptId: this.editStatus.deptId,
                };
                deptInfo(para).then(res => {
                    if (res.data.status==100) {
                        // console.log(res.data.results)
                        this.addEventForm = res.data.results
                        let para = {
                            deptId: res.data.results.preId
                        }
                        deptInfo(para).then(res => {
                            if (res.data.status==100) {
                                // console.log(res.data.results)
                                this.editStatus = res.data.results
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            /*树形控件删除节点*/
            removeEvent(s,d,n) {
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.addEventForm = Object.assign({}, d);
                console.log(this.addEventForm.deptId)
                this.$confirm('确定要删除该节点吗？', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let para = {
                        deptId: this.addEventForm.deptId
                    }
                    delDept(para).then((res) => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getDeptLists()
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                            this.getDeptLists()
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            /*树形控件查看节点*/
            WatchEvent(s,d,n) {
                this.triggerCurrenNodeData = d;
                this.triggerCurrenNode = n;
                this.watchEventForm = Object.assign({}, d);
                console.log(this.watchEventForm.deptId)
                //获取用户列表
                this.selectlogging()
            },
            /*节点新增，新增树形菜单事件分类弹窗，取消按钮*/
            addEventFormCancleBtn(){
                this.addEventdialogVisible = false;
            },
            /*节点新增，新增树形菜单事件分类弹窗，添加按钮 deptAdd*/
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        console.log('验证成功')
                        // console.log(this.triggerCurrenNode.level)
                        /*获取当前input上输入的文字*/
                        let para={
                            deptName: this.addEventForm.deptName,
                            deptCode: this.addEventForm.deptCode,
                            deptLinkman: this.addEventForm.deptLinkman,
                            deptLinkmanPhone: this.addEventForm.deptLinkmanPhone,
                            deptLinkmanEmail: this.addEventForm.deptLinkmanEmail,
                            preId: this.triggerCurrenNodeData.deptId,
                            dLevel: this.triggerCurrenNode.level+1 ,//当前节点层级
                            memo: this.addEventForm.memo,
                        }
                        deptAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.addEventdialogVisible = false;
                                this.$refs[formname].resetFields();
                                /*刷新树形菜单*/
                                this.getDeptLists();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            /*节点修改，修改树形菜单事件分类弹窗，保存按钮 ,deptEdit*/
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        console.log('验证成功')
                        /*获取当前input上输入的文字*/
                        console.log(this.triggerCurrenNodeData.deptId)
                        let para={
                            deptId: this.triggerCurrenNodeData.deptId,
                            deptName: this.addEventForm.deptName,
                            deptCode: this.addEventForm.deptCode,
                            deptLinkman: this.addEventForm.deptLinkman,
                            deptLinkmanPhone: this.addEventForm.deptLinkmanPhone,
                            deptLinkmanEmail: this.addEventForm.deptLinkmanEmail,
                            memo: this.addEventForm.memo,
                        }
                        deptEdit(para).then(res => {
                            if (res.data.status ==100) {
                                // this.theData = res.data.results.Deptlist
                                // console.log(res.data.results)
                                this.$message({
                                    message: "恭喜你，修改成功",
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.addEventdialogVisible = false;
                                this.$refs[formname].resetFields();
                                /*刷新树形菜单*/
                                this.getDeptLists();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //显示新增用户
            handleAddForm: function(index,row) {
                // console.log(this.watchEventForm.deptId)
                if (this.watchEventForm.deptId == undefined) {
                    this.$message({
                        message: "请先选择对应的组织机构",
                        type: "waring"
                    });
                }else{
                    //this.watchEventForm.staffName = "";
                    this.addUserForm = {};
                    this.dialogAddFormVisible = true
                }
            },
            //确认新增用户
            createData: function() {
                // console.log(this.watchEventForm)
                // console.log(this.addUserForm)

                this.$refs.watchEventForm.validate((valid)=>{
                    if (valid) {
                        this.$refs.addUserForm.validate((valid) => {
                            if (valid) {
                                console.log('验证成功')
                                let para = { 
                                    deptId: this.watchEventForm.deptId,
                                    jobNo: this.addUserForm.jobNo,
                                    loginName: this.addUserForm.loginName,
                                    memo: this.addUserForm.memo,
                                    password: this.addUserForm.password,
                                    staffDuty: this.addUserForm.staffDuty,
                                    staffEmail: this.addUserForm.staffEmail,
                                    staffName: this.watchEventForm.staffName,
                                    staffPhone: this.addUserForm.staffPhone,
                                    staffSex: this.addUserForm.staffSex,
                                    region: this.addUserForm.region
                                };
                                userAdd(para).then(res => {
                                    if (res.data.status==100) {
                                        this.dialogAddFormVisible = false
                                        // console.log(res.data.results)
                                        this.$message({
                                            message: res.data.message,
                                            type: "success"
                                        });
                                        // console.log(this.watchEventForm)
                                        this.selectlogging()
                                        this.$refs.addUserForm.resetFields();
                                        this.$refs.watchEventForm.resetFields();
                                        this.$refs.regionAdd.clearCheckedNodes()
                                    }else{
                                        this.$message({
                                            message: res.data.message,
                                            type: "error"
                                        });
                                    }
                                }).catch((error) =>{
                                    this.$Message.error(error.message);
                                })
                            } else {
                                console.log('验证未通过');
                                // this.$message({
                                //     message: "验证未通过",
                                //     type: "error"
                                // });
                                // return false;
                            }
                        });
                    }else{
                        console.log('验证未通过');
                    }
                })
                
            },
            //显示编辑界面
            handleEditForm: function(index, row) {
                let _self=this
                this.dialogFormVisible = true;
                this.editForm = Object.assign({}, row);
                let para = { 
                    createUser: this.editForm.userId,
                };
                getUserInfoById(para).then(res =>{
                    if (res.status === 200) {
                        _self.addUserForm = res.data.results
                        console.info(_self.addUserForm.region)
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //确认修改用户
            updateData:function() {
                this.$refs.editForm.validate(valid => {
                    if(valid){
                        this.$refs.addUserForm.validate(valid => {
                            if (valid) {
                                this.addUserForm.staffName = this.editForm.staffName;
                                this.$confirm("确认提交吗？", "提示", {}).then(() => {
                                    let para = Object.assign({}, this.addUserForm);
                                    userEdit(para).then(res => {
                                        this.$message({
                                            message: "提交成功",
                                            type: "success"
                                        });
                                        this.$refs["addUserForm"].resetFields();
                                        //this.editFormVisible = false;
                                        this.dialogFormVisible = false;
                                        //获取组织机构列表
                                        let para = { 
                                            deptId: this.watchEventForm.deptId,
                                            startRow: this.pages.page,
                                            pageSize: this.pages.pageSize
                                        };
                                        getUserListByDept(para).then(res => {
                                            if (res.status===200) {
                                                this.configureInfo = res.data.results.list
                                                this.pages.pageSize = res.data.results.pageSize
                                                this.pages.page = res.data.results.pageNum
                                                this.pages.total = res.data.results.total
                                                this.$refs.regionUpdate.clearCheckedNodes()
                                                // console.log(this.configureInfo)
                                            }
                                        }).catch((error) =>{
                                            this.$Message.error(error.message);
                                        })
                                        // this.getUsers();
                                    });
                                }).catch(e => {
                                    // 打印一下错误
                                     console.log(e);
                                });
                            }
                        });
                    }
                })
                
            },
            //删除用户
            handleDel: function(index, row) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.editForm = Object.assign({}, row);
                    //NProgress.start();
                    let para = { userId: this.editForm.userId };
                    userDel(para).then(res => {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        //获取组织机构列表
                        let para = { 
                            deptId: this.watchEventForm.deptId,
                            startRow: this.pages.page,
                            pageSize: this.pages.pageSize
                        };
                        getUserListByDept(para).then(res => {
                            if (res.status===200) {
                                this.configureInfo = res.data.results.list
                                this.pages.pageSize = res.data.results.pageSize
                                this.pages.page = res.data.results.pageNum
                                this.pages.total = res.data.results.total
                                // console.log(this.configureInfo)
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    });
                }).catch(() => {});
            },
            //重置密码
            changePassword:function(index,row) {
                this.$confirm("你确定重置所选帐号的密码？重置后的密码为jhh123456", "提示", {
                    type: "warning"
                }).then(() => {
                    this.editForm = Object.assign({}, row);
                    //NProgress.start();
                    let para = { userId: this.editForm.userId };
                    userResPwd(para).then(res => {
                        this.$message({
                            message: "重置成功",
                            type: "success"
                        });
                        //获取组织机构列表
                        let para = { 
                            deptId: this.watchEventForm.deptId,
                            startRow: this.pages.page,
                            pageSize: this.pages.pageSize
                        };
                        getUserListByDept(para).then(res => {
                            if (res.status===200) {
                                this.configureInfo = res.data.results.list
                                this.pages.pageSize = res.data.results.pageSize
                                this.pages.page = res.data.results.pageNum
                                this.pages.total = res.data.results.total
                                // console.log(this.configureInfo)
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    });
                }).catch(() => {});
            },
            //账号授权
            numberQuery:function (index,row) {
                this.dislogNumberQuery = true;
                this.NumberQueryForm = Object.assign({}, row);
                console.log(this.NumberQueryForm)
                //获取账号授权页面展示信息查询
                let para = { 
                    userId: this.NumberQueryForm.userId,
                };
                getAuthInfo(para).then(res => {
                    if (res.status===200) {
                        //单选按钮赋值
                        this.roleList = res.data.results.roleList
                        this.userRole.checked = res.data.results.userRole
                        console.log(this.roleList)
                        console.log(this.userRole.checked)
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //确认账号授权
            numberQueryAgin:function (){
                // console.log(this.NumberQueryForm.userId)
                // console.log(this.userRole.checked)
                this.$confirm("确认提交吗？", "提示", {}).then(() => {
                    let para = {
                        roleId:this.userRole.checked,
                        createUser:this.NumberQueryForm.userId,
                    }
                    userAuth(para).then(res => {
                        if (res.data.status == 100) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.dislogNumberQuery = false;
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    });
                }).catch(e => {
                    // 打印一下错误
                    console.log(e);
                });
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pages.pageSize = val
                // console.log(this.watchEventForm.deptId)
                this.selectlogging()
            },
            handleCurrentChange(Page) {
                // console.log(`当前页: ${Page}`);
                this.pages.page = Page
                // console.log(this.configureInfo.currentPage)
                this.selectlogging()
            },
            //获取用户信息
            selectlogging() {
                let para = { 
                    deptId: this.watchEventForm.deptId,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                };
                getUserListByDept(para).then(res => {
                    if (res.status===200) {
                        this.configureInfo = res.data.results.list
                        this.pages.pageSize = res.data.results.pageSize
                        this.pages.page = res.data.results.pageNum
                        this.pages.total = res.data.results.total
                        // console.log(this.configureInfo)
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getRegion(params){
                getRegionTree(params).then(result=>{
                    if(result.status===200){
                        this.regionData=result.data.results
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            regionChange(node){
                console.log(node)
            }
        }
    }
</script>
<style lang="scss">
    .el-tree-node__content{
        span{
            span{
                span{
                    display:inline-block;
                    *display:inline;
                    *zoom:1;
                    max-width:120px;
                    overflow:hidden;
                    text-overflow:ellipsis
                }
            }
        }
    }
</style>
<style scoped>
    @import '../../assets/css/logistics.css';
   .personZuzhi .box-card{margin-bottom: 20px;border-radius: 0px;width: 35%;}
   .personZuzhi .box-card .header{background-color: #f5f5f5}
   .personZuzhi .box-card .card-header{font-size: 14px;}
   .personZuzhi .box-card-big{width: 60%;margin-left: 20px;}
   .personZuzhi .toolbar{margin-top: 20px;}
   .icon {display: inline-block;width: 15px;height: 15px;background-repeat: no-repeat;vertical-align: -2px;}
   .folder {background-image: url(../../assets/images/folder.png);}
   .folder-open {background-image: url(../../assets/images/folder-open.png);}
   .file-text {background-image: url(../../assets/images/file-text.png);}
   .loading {background-image: url(../../assets/images/loading.gif);background-size: 15px;}
   .menuLi{cursor: pointer;}
   .menuLi > span{display: none;}
   .menuLi > span i{border:1px solid transparent;margin: 0 2px;}
   .menuLi:hover > span{display: inline-block;}
   .menuLi > span i:hover{border:1px solid #999;}
   .personZuzhi .el-form-item__content .el-textarea .el-textarea__inner{height: 50px;}
</style>


// WEBPACK FOOTER //
// personZuzhi.vue?c778c744